const navigateMenu = [
	{
		url: "/login/active-logins/settings",
		label: "Settings > Login > Active Logins > Settings",
		settings: [
			"Enable Active Logins Logic",
			"Maximum Active Logins",
			"Force Logout",
		],
	},
	{
		url: "/login/active-logins/automations",
		label: "Settings > Login > Active Logins > Automations",
		settings: ["Delete Sessions"],
	},
	{
		url: "/login/login-security/login-url",
		label: "Settings > Login > Login Security > Login URL",
		settings: [
			"Login page URL",
			"Old login page URL redirect",
			"Show a consent message on the login page?",
			"Consent message",
		],
	},
	{
		url: "/login/login-security/password-policies",
		label: "Settings > Login > Login Security > Password Policies",
		settings: [
			"Enable password & login security policies",
			"Password policies",
			"Password expiration policy",
			"Disallow old passwords on reset",
			"Reset password on first login",
			"Disable sending of password reset links",
			"Set content of the Password Reset Link",
		],
	},
	{
		url: "/login/login-security/use-admin-password",
		label: "Settings > Login > Active Logins > Use Administration Password",
		settings: ["Enable Administrator Password", "User roles"],
	},
	{
		url: "/login/express-login/settings",
		label: "Settings > Login > Express Login > Settings",
		settings: [
			"Enable Express Login",
			"Secret Key",
			"Link Expiry",
			"Redirect To",
			"Export Users",
			"Download .csv",
		],
	},
	{
		url: "/login/temporary-login/create",
		label: "Settings > Login > Temporary Login > Create Temporary Login",
		settings: ["Create a new Temporary Login", "Temporary User List"],
	},
	{
		url: "/login/temporary-login/settings",
		label: "Settings > Login > Temporary Login > Settings",
		settings: [
			"Visible Roles",
			"Default Role",
			"Default Redirect After Login",
			"Default Expiry Time",
		],
	},
	{
		url: "/login/2fa/settings",
		label: "Settings > Login > 2FA > Settings",
		settings: [
			"Activate two factor authentication",
			"Email Verification",
			"Allow grace period",
			"Enable 2FA for",
			"2FA Authenticator Applications",
			"Enable for",
			"Advanced settings",
			"XMLRPC requests",
			"Encrypt keys in database",
		],
	},
	{
		url: "/login/2fa/user-list",
		label: "Settings > Login > 2FA > User List",
		settings: ["User List"],
	},
	{
		url: "/security/anti-bot/re-captcha",
		label: "Settings > Security > Site Security > reCAPTCHA",
		settings: [
			"Enable reCAPTCHA on Signup",
			"reCAPTCHA Version",
			"Site Key",
			"Secret Key",
			"Error message reCAPTCHA verification failed",
			"Error message reCAPTCHA Blank",
			"Error message for can not connect to server",
			"reCAPTCHA Field Title",
			"reCAPTCHA Theme",
			"reCAPTCHA Size",
			"No-Conflict Mode",
			"Woo Registration reCAPTCHA",
		],
	},
	{
		url: "/security/anti-bot/cloudflare-turnstile",
		label: "Settings > Security > Site Security > Cloudflare Turnstile",
		settings: [
			"Site Key",
			"Secret key",
			"Theme",
			"Language",
			"Disable Submit Button",
			"Widget Size",
			"Appearance Mode",
			"Defer Scripts",
			"Custom Error Message",
			"Extra Failure Message",
			"Whitelist Settings",
			"Logged In Users",
			"IP Adddresses",
			"User Agents",
			"Enable Turnstile on your forms",
			"Default WordPress Forms",
			"WordPress Login",
			"WordPress Register",
			"WordPress Reset Password",
			"WordPress Comment",
		],
	},
	{
		url: "/security/brute-force/login-limit",
		label: "Settings > Security > Site Security > Login Limit",
		settings: [
			"Login Limit",
			"Login Attempts",
			"Lockout Duration",
			"Increase Login attempts",
			"Increase Lockout Duration",
			"Retries Reset Duration",
			"Block Users",
			"Recovery URL",
		],
	},
	{
		url: "/security/data-security/disable-right-click",
		label: "Settings > Security > Data Security > Disable Right Click",
		settings: [
			"Disable Right Click On Whole Site",
			"Disable Right Click For Pages.",
			"Disable Right Click For Product Pages",
			"Disable Right Click For Custom URLs",
			"Disable For User Roles",
		],
	},
	{
		url: "/security/blacklist-manager/email-blacklist",
		label: "Settings > Security > Blacklist Manager > Email Blacklist",
		settings: ["Enable email blacklist", "Block these email addresses"],
	},
	{
		url: "/security/blacklist-manager/address-blacklist",
		label: "Settings > Security > Blacklist Manager > Address Blacklist",
		settings: [
			"Enable Address Blacklist",
			"Percentage of similarity",
			"Blacklisted addresses",
		],
	},
	{
		url: "/security/salt-change/settings",
		label: "Settings > Security > Salt Change > Settings",
		settings: [
			"AUTH_KEY",
			"SECURE_AUTH_KEY",
			"LOGGED_IN_KEY",
			"NONCE_KEY",
			"AUTH_SALT",
			"SECURE_AUTH_SALT",
			"LOGGED_IN_SALT",
			"NONCE_SALT",
			"Scheduled Change",
			"Change WordPress salt keys",
			"Set Manual Time",
			"Reminder for Changing Salt Keys",
			"Notification Before Change",
			"Immediate Change",
		],
	},
	{
		url: "/security/privacy-manager/api-privacy",
		label: "Settings > Security > Privacy Manager > API Privacy",
		settings: [
			"Enable API Privacy",
			"User-Agent URL",
			"Options",
			"Strip WordPress version information from User-Agent",
			"Strip external plugins from API calls",
			"Strip external themes from API calls",
			"Modify data sent to core update API",
			"Strip wp_blog and wp_install headers",
			"Strip user login info from JSON API",
			"Debug",
			"Disable HTTPs for packet sniffing (should only be used for testing)",
		],
	},
	{
		url: "/security/update-manager",
		label: "Settings > Security > Update Manager",
		settings: [
			"General settings for WordPress, plugins and themes updates",
			"Core Updates",
			"Plugin Updates",
			"Theme Updates",
			"Disable Automatic Translation Updates",
			"Enable updates for VCS Installations",
			"Updates nags only for Admin",
			"Email Notifications",
			"Notification Customization",
			"Email address",
			"Send Test Email",
			"Default WordPress Core Email Notification",
			"Core notifications",
			"Advanced Options",
			"Force Automatic Updates",
			"Force updates",
			"Pluhins List",
			"Themes List",
		],
	},
	{
		url: "/security/url_guard/overview",
		label: "Settings > Security > Update Manager",
		settings: [
			"General settings for WordPress, plugins and themes updates",
			"Core Updates",
			"Plugin Updates",
			"Theme Updates",
			"Disable Automatic Translation Updates",
			"Enable updates for VCS Installations",
			"Updates nags only for Admin",
			"Email Notifications",
			"Notification Customization",
			"Email address",
			"Send Test Email",
			"Default WordPress Core Email Notification",
			"Core notifications",
			"Advanced Options",
			"Force Automatic Updates",
			"Force updates",
			"Pluhins List",
			"Themes List",
		],
	},
	{
		url: "/security/privacy-manager/api-privacy",
		label: "Settings > Security > URL Guard > Overview",
		settings: ["Enable URL Guard", "Request Methods"],
	},
	{
		url: "/security/url_guard/requests_log",
		label: "Settings > Security > URL Guard > Request Logs",
		settings: ["Logs", "Query Param"],
	},
	{
		url: "/security/recommendations",
		label: "Settings > Security > Recomendations",
		settings: [
			'Disable "anyone can register"',
			"Disable the built-in file editors",
			"Prevent specific file types (e.g. .php, .js, .mp4) in 'Uploads' folder",
			"Hide your WordPress version",
			"Prevent login feedback",
			"Disable user enumeration",
			"Unset X-Powered-By header",
			"Block the username 'admin','administrator','superadmin','root','manager'",
			"Prevent the same login and display name on user registration by making them different.",
			"Hide Admin Bar From Frontend",
			"Hide Admin Bar From Backend",
			"Disable WordPress Core Auto Updates",
			"Disable Plugin Auto Updates",
			"Disable Theme Auto Updates",
			"Remove RSD Link",
			"Hide WordPress Version",
			"Remove WLW Manifest Link",
			"Remove Shortlink",
			"Enable Shortcode in WP Widgets",
			"Hide CSS File Version",
			"Hide JS File Version",
			"Disable Dashicons in Frontend",
			"Disable Embeds",
			"Disable RSS Feed",
			"Remove RSS Feed Links",
			"Add Feature Image To RSS Feed",
		],
	},
	{
		url: "/restrictions/ip-restrictions/settings",
		label: "Settings > Restrictions > IP Restrictions > Settings",
		settings: [
			"Restrict site access to visitors who aren't logged in or allowed by IP address",
			"Handle restricted visitors",
			"Unrestricted IP Addresses",
			"Debug Log On/Off:",
		],
	},
	{
		url: "/more/site-health-info",
		label: "Settings > More > Site Health Info",
		settings: ["WordPress Configuration Information"],
	},
	{
		url: "/more/comments-cleaner",
		label: "Settings > More > Comments Cleaner",
		settings: [
			"Global Comments",
			"Select post types",
			"Activate two factor authentication",
			'Remove "site" in the comment form',
			"Remove external links in the comments",
			"Replace external links from authors bio",
			"Remove all comments",
			"Remove spam comments",
			"Remove unapproved comments",
			"Remove trashed comments",
		],
	},
	{
		url: "/more/error-notification",
		label: "Settings > More > Error Notification",
		settings: [
			"Notification Email",
			"Send Test Email",
			"Error Levels To Notify",
			"E_ERROR",
			"E_WARNING",
			"E_PARSE",
			"E_NOTICE",
			"E_USER_ERROR",
			"E_USER_WARNING",
			"E_STRICT",
			"E_DEPRECATED",
		],
	},
	{
		url: "/more/import-export",
		label: "Settings > More > Settings export/import",
		settings: ["Export Settings", "Download .json", "Import Settings"],
	},
	{
		url: "/more/extra",
		label: "Settings > More > Extra",
		settings: [
			"Uninstall option",
			"Delete all the plugin data upon uninstalling.",
			"Enable debug logging of Turnstile form submission events.",
		],
	},
];
if (ultimate_security_ajax_obj.isPro == 1) {
	navigateMenu.push(
		{
			url: "/login/passkeys/overview",
			label: "Settings > Login > Passkeys > Overview",
			settings: [
				"Statistics",
				"Overview of Authenticators",
				"Last Login Activity",
			],
		},
		{
			url: "/login/passkeys/settings",
			label: "Settings > Login > Passkeys > Settings",
			settings: [
				"Enable Passkeys",
				"Enable Maximum Passkeys",
				"Enable or disable the restriction for the maximum number of passkeys per user.",
				"Max Passkeys Number",
				"Enabled User Roles",
				"Exclude Existing Credentials",
				"Registration Timeout",
				"Login Timeout",
				"Enable User Verifications",
			],
		},
		{
			url: "/login/passkeys/display",
			label: "Settings > Login > Passkeys > Display",
			settings: [
				"Login for WooCommerce",
				"The WooCommerce plugin must be installed and activated to work correctly.",
				"Login for MemberPress",
				"Enable Passkey Login for MemberPress login form.",
				"Login for Easy Digital Downloads",
				"Enable Passkey Login for Easy Digital Downloads login form.",
				"Login Short Code",
				"Register Short Code",
				"Display Passkeys in Users List",
				"Display Passkeys in Edit User/Profile",
			],
		},
		{
			url: "/login/passkeys/advanced",
			label: "Settings > Login > Passkeys > Advanced",
			settings: ["Delete log records older than"],
		},
	);
}
export default navigateMenu;
